export default "__VITE_ASSET__DMh0JMx3__"